import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { Skeleton, Typography } from '@blade/ui-kit'
import { isLoggedInAtom } from '@root/entities/auth'
import { recentSearchesModelAtom } from '@root/features/user/recent-searches'
import { useTranslation } from '@root/shared/localization'

import { SearchRecentList } from './search-recent-list'

import type { Pair } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type SearchRecentProps = {
  onPairSelected?: (pair: Pair.PairMinimal) => void
} & ClassNameProps

export const SearchRecent: React.FC<SearchRecentProps> = ({
  className,
  onPairSelected,
}) => {
  const { t } = useTranslation()
  const [model] = useAtom(recentSearchesModelAtom)
  const [recentSearchesState] = useAtom(model.recentSearchesAtom)
  const [isLoggedIn] = useAtom(isLoggedInAtom)

  if (!isLoggedIn) {
    return undefined
  }

  return (
    <Root className={className}>
      <Label>{t('search.recents')}:</Label>
      {AsyncStateN.matchWaiting(recentSearchesState, {
        Success: (recentPairs) => {
          if (recentPairs.length === 0) {
            return <Label>{t('search.no-recent-searches')}</Label>
          }

          return (
            <SearchRecentList
              pairs={recentPairs}
              onPairSelected={onPairSelected}
            />
          )
        },
        Error: () => undefined,
        Waiting: () => <Skeleton width={50} height={20} />,
      })}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px;
  grid-row: recents;

  justify-content: start;
  align-items: center;
  overflow: hidden;

  padding-inline: 15px;

  height: 40px;
`

const Label = styled(Typography)`
  color: var(--textA-8);
`
